import { api } from './client';

export const CUSTOM_FRAMEWORK_PREFIX = 'custom:';

export function storyFrameworkRef(dto) {
  if (!dto) return null;
  return dto.source === 'custom' ? `${CUSTOM_FRAMEWORK_PREFIX}${dto.id}` : dto.id;
}

export function parseStoryFrameworkRef(ref) {
  if (!ref) return null;
  if (ref.startsWith(CUSTOM_FRAMEWORK_PREFIX)) {
    return { source: 'custom', id: ref.slice(CUSTOM_FRAMEWORK_PREFIX.length) };
  }
  return { source: 'library', id: ref };
}

export async function resolveStoryFrameworkLabel(ref) {
  const meta = await resolveStoryFrameworkMeta(ref);
  return meta?.framework_name || null;
}

export async function resolveStoryFrameworkMeta(ref) {
  const parsed = parseStoryFrameworkRef(ref);
  if (!parsed) return null;
  try {
    const dto = parsed.source === 'custom'
      ? await frameworksApi.getCustom(parsed.id)
      : await frameworksApi.getLibrary(parsed.id);
    return {
      framework_name: dto.framework_name,
      thin_genre: Boolean(dto.thin_genre),
      genre_tag: dto.genre_tag || null,
      dto,
    };
  } catch {
    return { framework_name: parsed.id, thin_genre: false, genre_tag: null, dto: null };
  }
}

export const frameworksApi = {
  catalog: () => api.get('/frameworks'),
  getLibrary: (key) => api.get(`/frameworks/library/${encodeURIComponent(key)}`),
  copyLibrary: (key, frameworkName) =>
    api.post(`/frameworks/library/${encodeURIComponent(key)}/copy`, {
      framework_name: frameworkName,
    }),
  getCustom: (id) => api.get(`/frameworks/custom/${id}`),
  createCustom: (body) => api.post('/frameworks/custom', body),
  updateCustom: (id, body) => api.put(`/frameworks/custom/${id}`, body),
  copyCustom: (id, frameworkName) =>
    api.post(`/frameworks/custom/${id}/copy`, { framework_name: frameworkName }),
  deleteCustom: (id) => api.delete(`/frameworks/custom/${id}`),
  exportSelected: (ids) => api.post('/frameworks/export', { ids }),
  importBundle: (body) => api.post('/frameworks/import', body),
  createTurn: (body) => api.post('/frameworks/create/turn', body),
  createTalk: (body) => api.post('/frameworks/create/talk', body),
  createBuild: (body) => api.post('/frameworks/create/build', body),
  latestExplainer: () => api.get('/frameworks/explainer'),
};

export function suggestedCopyName(original) {
  const base = (original || '').trim() || 'Framework';
  return `${base} - copy`;
}

export function formatFrameworkError(err) {
  const detail = err?.message;
  if (detail && typeof detail === 'object') {
    const field = detail.field ? `${detail.field}: ` : '';
    return `${field}${detail.message || 'Could not save that Framework.'}`;
  }
  if (typeof detail === 'string' && detail !== '[object Object]') {
    return detail;
  }
  return err?.message || 'Something went wrong.';
}
